// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"c4bf0ce0","320":"c0bd6780","614":"28743e7e","734":"563eecc6"}[chunkId] + ".chunk.js";
};